import axios from 'axios'
import { crawlerHost, host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-game-results'

// count-printed-ticket
export const getCountTicket = async (token, gamePeriodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/count-printed-ticket`, {
        gamePeriodId: gamePeriodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data.count || 0
    }
    return 0
}

// confirm-number-ticket
export const confirmNumberTicket = async (token, gamePeriodId, numberTicket) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/confirm-number-ticket`, {
        gamePeriodId: gamePeriodId,
        numberTicket: numberTicket
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return true
    }
    return false
}

// keno
export const getKenoResults = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-keno`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const addKenoResults = async (token, periodId, numbers) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/add-keno`, {
        periodId: periodId,
        numbers: numbers
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const editKenoResults = async (token, periodId, numbers) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/edit-keno`, {
        periodId: periodId,
        numbers: numbers
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// max3d
export const getMax3dResults = async (token, page, period = '') => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-max3d`, {
        page: page,
        itemPerPage: getItemPerPage(),
        period: period
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const addMax3dResults = async (token, periodId, numbers) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/add-max3d`, {
        periodId: periodId,
        numbers: numbers
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const editMax3dResults = async (token, periodId, numbers) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/edit-max3d`, {
        periodId: periodId,
        numbers: numbers
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// max3dpro
export const getMax3dProResults = async (token, page, period = '') => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-max3dpro`, {
        page: page,
        itemPerPage: getItemPerPage(),
        period: period
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const addMax3dProResults = async (token, periodId, numbers) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/add-max3dpro`, {
        periodId: periodId,
        numbers: numbers
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const editMax3dProResults = async (token, periodId, numbers) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/edit-max3dpro`, {
        periodId: periodId,
        numbers: numbers
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// mega
export const getLotto535Results = async (token, page, period = '') => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-lotto535`, {
        page,
        itemPerPage: getItemPerPage(),
        period
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    return response && response.status === 200 ? response.data || {} : {}
}

export const saveLotto535Result = async (token, payload, editing = false) => {
    const action = editing ? 'edit-lotto535' : 'add-lotto535'
    const response = await axios.post(`${host}/${PLUGINS_NAME}/${action}`, payload, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })
    return response && response.status === 200 ? response.data || {} : {}
}

// mega
export const getMegaResults = async (token, page, period = '') => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-mega`, {
        page: page,
        itemPerPage: getItemPerPage(),
        period: period
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const addMegaResults = async (token, resultInput) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/add-mega`, resultInput, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const editMegaResults = async (token, periodId, numbers) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/edit-mega`, {
        periodId: periodId,
        numbers: numbers
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// power
export const getPowerResults = async (token, page, period = '') => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-power`, {
        page: page,
        itemPerPage: getItemPerPage(),
        period: period
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const addPowerResults = async (token, resultInput) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/add-power`, resultInput, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const editPowerResults = async (token, periodId, numbers) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/edit-power`, {
        periodId: periodId,
        numbers: numbers
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// crawler preview & trigger
export const previewMax3dCrawler = async () => {
    const response = await axios.get(`${crawlerHost}/api/preview/max3d`)

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const previewMax3dProCrawler = async () => {
    const response = await axios.get(`${crawlerHost}/api/preview/max3dpro`)

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const triggerMax3dCrawler = async () => {
    const response = await axios.post(`${crawlerHost}/api/crawl/max3d`)

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const triggerMax3dProCrawler = async () => {
    const response = await axios.post(`${crawlerHost}/api/crawl/max3dpro`)

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}
